var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90005 19.3326C8.43451 19.6599 8.07193 19.7506 7.29603 19.7022C4.64605 19.5083 2.55859 15.8125 2.55859 12.563C2.55859 9.65425 4.13426 7.96887 6.03222 7.96887C7.30946 7.96887 8.46733 8.64756 9.1358 9.09599C9.9475 8.2355 11.1293 7.71436 12.2871 7.71436C14.4716 7.71436 15.8443 9.5323 15.8443 12.2706C15.8443 12.9978 15.7339 13.497 15.6145 14.0303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9797 8.99986C9.08067 7.30233 8.21239 6.02918 7.27344 5.57129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98884 6.85669C8.95168 4.42327 10.7604 3.31606 12.8416 3.43773C12.9407 5.25063 11.1072 6.89319 8.98884 6.85669Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0565 10.6758V8.43531C19.0565 8.27701 19.189 8.14307 19.3455 8.14307H20.2728C20.4294 8.14307 20.5498 8.27701 20.5498 8.43531V10.8341C21.2121 11.3821 21.4169 12.1005 21.4169 12.9164C21.4169 16.8016 17.1041 21.4288 12.6974 21.4288C10.3972 21.4288 8.98828 20.2354 8.98828 18.896C8.98828 17.934 9.759 17.3008 10.6501 17.0451C14.4074 15.8883 17.2246 13.5991 19.0573 10.6751L19.0565 10.6758Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7031 18.4284C16.1978 17.5184 18.3488 15.7778 18.846 14.5713"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.f930f7e1612c33511393ba353086abb8.svg";
export { ForwardRef as ReactComponent };